import { IconProps } from "@/types/icons";
import clsx from "clsx";

export const Support = ({
  width = 40,
  height = 40,
  className,
  decorative = false,
  ariaLabel = "Support",
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 40 40"
      className={clsx(className)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="#06C"
        fillRule="evenodd"
        d="M3.334 20c0-9.205 7.462-16.666 16.667-16.666A16.667 16.667 0 0 1 36.667 20c0 9.205-7.462 16.667-16.666 16.667S3.334 29.205 3.334 20m1.667 0c0 8.284 6.715 15 15 15s15-6.716 15-15S28.285 5 20 5C11.716 5 5 11.716 5 20m13 7.5h2v3h-2zm7-10.333a7 7 0 0 0 .5-3 4.5 4.5 0 0 0-1.334-3.667 8.17 8.17 0 0 0-4.5-1 17 17 0 0 0-5 .834v1.333h.834l3.833-.5a5.83 5.83 0 0 1 3.333.667 2.83 2.83 0 0 1 1 2.333 4.33 4.33 0 0 1-.5 2.333 10.7 10.7 0 0 1-2 2.167A15 15 0 0 0 18.834 21a3.5 3.5 0 0 0-.833 2c.015.57.128 1.134.333 1.667h1.5v-1a4.7 4.7 0 0 1 .667-2l2.333-2.167a9 9 0 0 0 2.167-2.333"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
